/* eslint-disable @typescript-eslint/no-magic-numbers */
import type { LayerSpecification } from 'maplibre-gl';

const black = '#000';
const white = '#fff';

/**
 * generate map layers to render clusters
 */
export function generate_cluster_layers(): Array<LayerSpecification> {
    return [
        {
            id: 'pin',
            type: 'circle',
            source: 'pins',
            filter: ['!', ['has', 'point_count']],
            paint: {
                'circle-radius': 0,
                'circle-opacity': 0,
            },
        },
        {
            id: 'clusters_pins_shadows',
            type: 'circle',
            source: 'pins',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': black,
                'circle-opacity': 0.1,
                'circle-blur': 0.5,
                'circle-radius': [
                    '+',
                    20,
                    [
                        'min',
                        60,
                        [
                            '*',
                            20,
                            [
                                '^',
                                ['get', 'point_count'],
                                0.3,
                            ],
                        ],
                    ],
                ],
            },
        },
        {
            id: 'clusters_pins',
            type: 'circle',
            source: 'pins',
            filter: ['has', 'point_count'],
            paint: {
                'circle-color': white,
                'circle-radius': [
                    'min',
                    60,
                    [
                        '*',
                        20,
                        [
                            '^',
                            ['get', 'point_count'],
                            0.3,
                        ],
                    ],
                ],
            },
        },
        {
            id: 'cluster_count_pins',
            type: 'symbol',
            source: 'pins',
            filter: ['has', 'point_count'],
            layout: {
                'text-font': ['Open-Sans-Bold'],
                'text-field': ['get', 'point_count_abbreviated'],
                'text-size': [
                    'min',
                    32,
                    [
                        '*',
                        10,
                        [
                            '^',
                            ['get', 'point_count'],
                            0.3,
                        ],
                    ],
                ],
            },
            paint: {
                'text-color': black,
            },
        },
    ];
}
